import FootballState from "../../../state/football-state";
import Rule from "../../../../common/rule";

export default class FirstDown extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            ruleContext.awardFirstDown &&
            gameContext.gameConfig.general.firstDownFlagStyle <= 0 &&
            [
                FootballState.EndOfPlay,
                FootballState.NoPenaltyEndOfPlay,
                FootballState.GameStart,
                FootballState.CoinToss,
                FootballState.StartPeriod,
                FootballState.SkipKickoff
            ].some((state) => state === fragment.associatedState)
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { gameConfig, fieldPosition } = gameContext;

        gameContext.down = 1;
        gameContext.setFirstDownAt(
            fieldPosition +
                gameConfig.general.firstDownYards *
                    gameContext.getFieldDirectionMultiplier()
        );
        ruleContext.setAwardFirstDown(false);
    }
}
